var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9516 18.9993C28.9516 13.5027 24.4958 9.04688 18.9993 9.04688C13.5027 9.04688 9.04688 13.5027 9.04688 18.9993C9.04688 23.9668 12.6863 28.0841 17.4442 28.8307V21.8761H14.9172V18.9993H17.4442V16.8066C17.4442 14.3123 18.93 12.9345 21.2033 12.9345C22.2922 12.9345 23.4312 13.1289 23.4312 13.1289V15.5781H22.1762C20.9399 15.5781 20.5543 16.3453 20.5543 17.1324V18.9993H23.3145L22.8733 21.8761H20.5543V28.8307C25.3122 28.0841 28.9516 23.9668 28.9516 18.9993Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8733 21.8761L23.3145 18.9993H20.5543V17.1324C20.5543 16.3453 20.9399 15.5781 22.1762 15.5781H23.4312V13.1289C23.4312 13.1289 22.2922 12.9345 21.2033 12.9345C18.93 12.9345 17.4442 14.3123 17.4442 16.8066V18.9993H14.9172V21.8761H17.4442V28.8307C18.4746 28.992 19.5239 28.992 20.5543 28.8307V21.8761H22.8733Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.283adc676ac273cd69c53fb7d05eb627.svg";
export { ForwardRef as ReactComponent };